import { render, staticRenderFns } from "./ImportFiles.vue?vue&type=template&id=310de171&"
import script from "./ImportFiles.vue?vue&type=script&lang=js&"
export * from "./ImportFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('310de171')) {
      api.createRecord('310de171', component.options)
    } else {
      api.reload('310de171', component.options)
    }
    module.hot.accept("./ImportFiles.vue?vue&type=template&id=310de171&", function () {
      api.rerender('310de171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pain008/ImportFiles.vue"
export default component.exports